import { useEffect, useMemo } from 'react'
// import { TextField } from 'mui-rff'
import { TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { getYearFromDate } from '../../../../utils/getYearFromDate'
import { useOptionsContext } from './optionsContext'
import { useFieldValue } from '../../../../hooks/useFieldValue'
import * as types from '../../../../types'
import { useField } from 'react-final-form'

const uninsuredCodes = [
  'uninsured15',
  'uninsured30',
  'uninsured45',
  'uninsured60',
  'uninsured75',
  'uninsured90',
  'uninsured105',
  'uninsured120',
  'OV0012'
]

const noShowCodes = ['no_show', 'coulance']

// TODO: wtf is this
export const filterPrices = (
  price: types.ConsultationPrice,
  activity: types.Activity2022,
  treatmentType: types.TreatmentType
): boolean => {
  // Reiskosten should always follow their own codes/durations regardless of insured/uninsured
  if (activity.consultationType?.id === 34) {
    return (
      price.duration?.id === activity.duration?.id &&
      price.consultationType?.id === activity.consultationType?.id
    )
  }
  if (activity.consultationType?.id === 3) {
    // Intercollegiaal overleg
    return (
      price.duration?.id === activity.duration?.id &&
      price.consultationType?.id === activity.consultationType?.id
    )
  } else if (activity.consultationType?.id === 4) {
    // No-show
    return (
      noShowCodes.includes(price.code) &&
      price.duration?.id === activity.duration?.id
    )
  } else if (treatmentType.id === 2) {
    // Onverzekerde zorg
    return (
      uninsuredCodes.includes(price.code) &&
      price.duration?.id === activity.duration?.id
    )
  } else if (uninsuredCodes.includes(price.code)) {
    // hotfix 31.01.23
    // todo: find a proper way to remove prices of uninsured care
    return false
  }

  return (
    price.duration?.id === activity.duration?.id &&
    price.consultationType?.id === activity.consultationType?.id
  )
}

export const findPrice = (
  consultationPrices: types.ConsultationPrice[],
  activity: types.Activity2022,
  treatmentType: types.TreatmentType
): types.ConsultationPrice | undefined =>{
  const year = Number(getYearFromDate(activity.date)) || new Date(activity?.date || Date.now()).getFullYear()
  // candidates that match activity/treatment regardless of year
  const candidates = consultationPrices.filter((price) =>
    filterPrices(price, activity, treatmentType)
  )
  // Prefer exact-year price
  const exact = candidates.find((p) => p.year === year)
  if (exact) return exact
  // Fallback: latest price not newer than the activity year
  const notNewer = candidates
    .filter((p) => typeof p.year === 'number' && p.year <= year)
    .sort((a, b) => (b.year as number) - (a.year as number))
  if (notNewer[0]) return notNewer[0]
  // Last resort: take the newest available
  return candidates.sort((a, b) => (b.year as number) - (a.year as number))[0]
}

export const ConsultationPriceField = ({
  rootName,
  disabled
}: {
  rootName: string
  disabled: boolean
}): JSX.Element => {
  const { t } = useTranslation('timeRegistrationSection')

  const activity = useFieldValue(rootName)
  // treatmentType comes from the section context so it is subscribed once for
  // the whole section rather than once per activity row (SLAAP-320).
  const { consultationPrices, treatmentType } = useOptionsContext()

  const {
    input: { onChange }
  } = useField(`${rootName}.consultationPrice.id`)

  // find price the matches the selected activity
  // (pricing is based on activity date, duration, and type)
  const price = useMemo(
    () => findPrice(consultationPrices, activity, treatmentType),
    [consultationPrices, activity, treatmentType]
  )

  // update value in the form so it can be submitted
  useEffect(() => onChange(price?.id), [price, onChange])

  // this is not a real form field, it's just for display
  // so we don't need the name prop
  return (
    <TextField
      value={
        price?.value
          ? new Intl.NumberFormat('nl-NL', {
              style: 'currency',
              currency: 'EUR'
            }).format(Number(price?.value))
          : ''
      }
      InputProps={{ readOnly: true }}
      disabled={disabled}
    />
  )
}
